var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-filter-input-text',{staticClass:"filter-text",attrs:{"filter":_vm.filter,"placeholder":"Quick search..."},on:{"ready":_vm.onReady}})
}
var staticRenderFns = []

export { render, staticRenderFns }